import { useTranslation } from "react-i18next";

export default function WhyChooseUs() {
  const { t } = useTranslation();

  const items = [
    {
      icon: "ri-refresh-line",
      title: t("why.item1.title"),
      text: t("why.item1.text"),
    },
    {
      icon: "ri-shield-check-line",
      title: t("why.item2.title"),
      text: t("why.item2.text"),
    },
    {
      icon: "ri-layout-grid-line",
      title: t("why.item3.title"),
      text: t("why.item3.text"),
    },
    {
      icon: "ri-compass-3-line",
      title: t("why.item4.title"),
      text: t("why.item4.text"),
    },
    {
      icon: "ri-bar-chart-grouped-line",
      title: t("why.item5.title"),
      text: t("why.item5.text"),
    },
    {
      icon: "ri-sparkling-line",
      title: t("why.item6.title"),
      text: t("why.item6.text"),
    },
  ];

  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <span className="text-xs font-semibold tracking-wider uppercase text-primary-600">
            {t("why.label")}
          </span>
          <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            {t("why.title")}
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("why.p1")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl bg-background-50 border border-background-200/50 p-6 transition-all hover:border-primary-200/60 hover:shadow-sm"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}